
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from './controlador';
    import listado from './lista-listado.vue';
    import cuentas from './barra-lateral-cuentas.vue';
    import buscador from './barra-lateral-buscador.vue';
    import filtros from './barra-lateral-filtros.vue';

    @Component( {
        name: "Componente",
        props: {},
        components: {
            listado,
            cuentas,
            buscador,
            filtros,
        }
    } )

    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorSeccion;
        public get Buscador() { return this.Controlador.Buscador; }
        public get Estado() { return this.Controlador.Buscador.Estado; }
        public get Items() { return this.Controlador.Buscador.Items; }
        public get MenuOculto() { return this.Controlador.Vista.MenuOculto; }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }
        mounted()
        {

        }

        public Ocultar()
        {
            this.Controlador.Vista.AlternarMenu();
        }
    }
